module.exports = __webpack_public_path__ + "img/philco_white.68664a93.svg";